const OPERATORS_STATISTICS = {
  OPERATORS_STATISTICS_HEADER_TITLE: 'آمار اپراتورها',
  OPERATORS_STATISTICS_HEADER_SUB_TITLE:
    'با انتخاب دوره زمانی دلخواه، می‌توانید کل و میانگین زمان فعالیت، تعداد مکالمات قبول شده و جزئیات آماری هر اپراتور را بررسی کنید.',
  OPERATORS_STATISTICS_MAIN_TITLE: 'آمار اپراتورها',
  OPERATORS_STATISTICS_TABLE_OPERATOR_COL_LABEL: 'اپراتور',
  OPERATORS_STATISTICS_TABLE_TOTAL_ACTIVE_COL_LABEL: 'کل زمان فعالیت',
  OPERATORS_STATISTICS_TABLE_AVG_ACTIVE_COL_LABEL: 'میانگین زمان فعالیت',
  OPERATORS_STATISTICS_TABLE_ACCEPTED_CONVS_LABEL: 'مکالمات قبول شده',
  OPERATORS_STATISTICS_TABLE_AVG_ANS_LABEL: 'میانگین زمان پاسخگویی',
  OPERATORS_STATISTICS_TABLE_AVG_CLOSE_LABEL: 'میانگین زمان بستن مکالمه',
  OPERATORS_STATISTICS_TABLE_CUSTOMER_SATISFACTION_LABEL: 'درصد رضایت مندی',
  OPERATORS_STATISTICS_TABLE_ACCEPTED_COL_PREFIX: 'مکالمه',
  OPERATORS_STATISTICS_TABLE_SCORE_LABEL: 'امتیاز از 100',
  OPERATORS_STATISTICS_TABLE_DETAILS_LABEL: 'جزئیات آمار',
  OPERATORS_STATISTICS_NO_OPERATOR_TO_DISPLAY: 'اپراتوری برای نمایش وجود ندارد',
  OPERATORS_STATISTICS_AVERAGE_ITEM_LABEL: 'میانگین',
  OPERATORS_STATISTICS_CSV_EXPORT_BTN_LABEL: 'خروجی csv',
  OPERATORS_STATISTICS_CSV_EXPORT_FILE_PREFIX: 'آمار اپراتورها',
  CSV_EXPORT_ACCESS_MSG:
    'برای استفاده از این ویژگی پکیج خود را به پریمیوم ارتقا دهید.',
  SCORE_ITEM_PREFIX: 'از 100 ',
};

export default OPERATORS_STATISTICS;
